export enum HiddenActionItemType {
  Delete = 0,
  Modify = 1,
  New = 2,
}
